/* eslint-disable no-bitwise */
/* eslint-disable prefer-destructuring */
import $ from 'jquery';
import Utilities from './utilities';

class BgLightHeader {
  constructor() {
    this.utilities = new Utilities();
  }

  init() {
    this.isLightText = $('.js-bottom-bg-light-text');

    if (!this.isLightText.length) {
      return;
    }

    const coloredElements = $('.has-text-color');
    const offset = 50;
    const bgOffsetTop = this.isLightText.offset().top + offset;

    const headings = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];

    if (coloredElements.length) {
      $.each(coloredElements, (i, el) => {
        const element = $(el);
        const color = element.css('color');
        const isLight = this.utilities.lightOrDark(color);

        if (element.attr('data-initial-color') === undefined) {
          element.attr('data-initial-color', color);
        }

        if (isLight) {
          const elementType = element.prop('nodeName');

          if (element.offset().top > bgOffsetTop) {
            element.css({ color: element.attr('data-initial-color') });
          } else {
            element.css({
              color: headings.includes(elementType) ? '#505c10' : '#232824',
            });
          }
        }
      });
    }
  }
}

export default BgLightHeader;



// WEBPACK FOOTER //
// ./src/scripts/modules/bg-light-header.js